/*
This file was created by the script build.py 
*/

import {buttonOnClick, checkAllButtons, callAllCategories} from "./globalFilterUI"
import {allCheckboxesState} from "./checkboxState"

// show or hide buttons
$(document).ready(function(){
    $("#iconWorkingGroup").click(function(){
        var buttons = document.getElementById("buttonWrapperWorkingGroup")
        const iconId = "#"+$(this).attr('id');
        if(buttons.classList.contains("show")){
            $(buttons).hide()
            buttons.classList.remove("show")
            $(iconId).toggleClass("bi bi-caret-up-fill", false)
            $(iconId).toggleClass("bi bi-caret-down-fill", true)
        }
        else{
            $(buttons).show()
            buttons.classList.add("show")
            $(iconId).toggleClass("bi bi-caret-down-fill", false)
            $(iconId).toggleClass("bi bi-caret-up-fill", true)
        }
    })
})

//checkbox Working Group
document.getElementById("categoryWorkingGroup").onclick=function(){
    const checkboxId = $(this).attr('id')
    var checkbox = document.getElementById(checkboxId)
    checkbox.checked = false
    if(allCheckboxesState[checkboxId].checked){
        checkbox.checked = true
    }
    else if(allCheckboxesState[checkboxId].indeterminate){
        checkbox.indeterminate = true
    }
    else{
        checkbox.checked = false
    }
    
    const iconId = "#iconWorkingGroup";
    var buttons = document.getElementById("buttonWrapperWorkingGroup")
    if(buttons.classList.contains("show")){
        $(buttons).hide()
        buttons.classList.remove("show")
        $(iconId).toggleClass("bi bi-caret-up-fill", false)
        $(iconId).toggleClass("bi bi-caret-down-fill", true)
    }
    else{
        $(buttons).show()
        buttons.classList.add("show")
        $(iconId).toggleClass("bi bi-caret-down-fill", false)
        $(iconId).toggleClass("bi bi-caret-up-fill", true)
    }
    allCheckboxesState[checkboxId].checked = checkbox.checked

}

//Name Working Group
document.getElementById("workingGroupLabel").onclick=function(){
    const iconId = "#iconWorkingGroup";
    var buttons = document.getElementById("buttonWrapperWorkingGroup")
    if(buttons.classList.contains("show")){
        $(buttons).hide()
        buttons.classList.remove("show")
        $(iconId).toggleClass("bi bi-caret-up-fill", false)
        $(iconId).toggleClass("bi bi-caret-down-fill", true)
    }
    else{
        $(buttons).show()
        buttons.classList.add("show")
        $(iconId).toggleClass("bi bi-caret-down-fill", false)
        $(iconId).toggleClass("bi bi-caret-up-fill", true)
    }
    
}

//Button: "select all buttons"
document.getElementById("buttonWorkingGroupSelectAll").onclick=function(){
    const checkboxId = "categoryWorkingGroup"
    var checkbox = document.getElementById(checkboxId)
    checkbox.indeterminate = false
    checkbox.checked = true
    allCheckboxesState[checkboxId].checked = checkbox.checked
    checkAllButtons({
        "checkboxId" : checkboxId
    })

    callAllCategories()
}

//Button: "select none buttons"
document.getElementById("buttonWorkingGroupSelectNone").onclick=function(){
    const checkboxId = "categoryWorkingGroup"
    var checkbox = document.getElementById(checkboxId)
    checkbox.checked = false
    checkbox.indeterminate = false
    allCheckboxesState[checkboxId].checked = checkbox.checked
    allCheckboxesState[checkboxId].indeterminate = checkbox.indeterminate
    checkAllButtons({
        "checkboxId" : checkboxId
    })

    callAllCategories()
}

// any-Button Working Group
document.getElementById("buttonWorkingGroupAny").onclick = function(){
    var buttonAny = document.getElementById("buttonWorkingGroupAny")
    var buttonAll = document.getElementById("buttonWorkingGroupAll")
    buttonAny.classList.add("chosen","text-light","no-click");
    buttonAll.classList.remove("chosen","text-light","no-click")
    callAllCategories()
}

// all-Button Working Group
document.getElementById("buttonWorkingGroupAll").onclick = function(){
    var buttonAny = document.getElementById("buttonWorkingGroupAny")
    var buttonAll = document.getElementById("buttonWorkingGroupAll")
    buttonAll.classList.add("chosen","text-light","no-click");
    buttonAny.classList.remove("chosen","text-light","no-click")
    callAllCategories()
}


//Button B2G in Working Group change color on click Event
document.getElementById("buttonWorkingGroupB2G").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button BPH in Working Group change color on click Event
document.getElementById("buttonWorkingGroupBPH").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button BTV in Working Group change color on click Event
document.getElementById("buttonWorkingGroupBTV").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button CFT in Working Group change color on click Event
document.getElementById("buttonWorkingGroupCFT").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button DIF in Working Group change color on click Event
document.getElementById("buttonWorkingGroupDIF").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button EGM in Working Group change color on click Event
document.getElementById("buttonWorkingGroupEGM").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button EWK in Working Group change color on click Event
document.getElementById("buttonWorkingGroupEWK").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button EXO in Working Group change color on click Event
document.getElementById("buttonWorkingGroupEXO").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button FSQ in Working Group change color on click Event
document.getElementById("buttonWorkingGroupFSQ").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button FTR in Working Group change color on click Event
document.getElementById("buttonWorkingGroupFTR").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button FWD in Working Group change color on click Event
document.getElementById("buttonWorkingGroupFWD").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button GEN in Working Group change color on click Event
document.getElementById("buttonWorkingGroupGEN").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button HIG in Working Group change color on click Event
document.getElementById("buttonWorkingGroupHIG").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button HIN in Working Group change color on click Event
document.getElementById("buttonWorkingGroupHIN").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button JME in Working Group change color on click Event
document.getElementById("buttonWorkingGroupJME").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button LUM in Working Group change color on click Event
document.getElementById("buttonWorkingGroupLUM").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button MUO in Working Group change color on click Event
document.getElementById("buttonWorkingGroupMUO").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button PFT in Working Group change color on click Event
document.getElementById("buttonWorkingGroupPFT").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button PPS in Working Group change color on click Event
document.getElementById("buttonWorkingGroupPPS").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button PRF in Working Group change color on click Event
document.getElementById("buttonWorkingGroupPRF").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button QCD in Working Group change color on click Event
document.getElementById("buttonWorkingGroupQCD").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button SBM in Working Group change color on click Event
document.getElementById("buttonWorkingGroupSBM").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button SMP in Working Group change color on click Event
document.getElementById("buttonWorkingGroupSMP").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button SUS in Working Group change color on click Event
document.getElementById("buttonWorkingGroupSUS").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button TAU in Working Group change color on click Event
document.getElementById("buttonWorkingGroupTAU").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button TOP in Working Group change color on click Event
document.getElementById("buttonWorkingGroupTOP").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button TRG in Working Group change color on click Event
document.getElementById("buttonWorkingGroupTRG").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button TRK in Working Group change color on click Event
document.getElementById("buttonWorkingGroupTRK").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

